import { UserEndPoints, pageNo } from "../../config";
import { getQueryStringFrmObject, postApi, getApi } from "../helpers/utility";

class CountryApi {
  create = async (userPojo) => {
    console.log("userpojo", userPojo);
    if (userPojo) {
      //   console.log("Country pojo", JSON.stringify(userPojo));
      var result = await postApi(UserEndPoints.add, userPojo);
      return result;
    }
  };

  read = async (readFilter, page) => {
    let finalListEndPoint;
    finalListEndPoint = UserEndPoints.list + "?pageNo=" + page + "&per_page=" + pageNo;
    let searchParams = { info: readFilter };
    if (searchParams.info) {
      var queryString = getQueryStringFrmObject(searchParams);
      finalListEndPoint = finalListEndPoint + "&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    return result;
  };

  findById = async (userId) => {
    var result = await getApi(UserEndPoints.findById, userId);
    return result;
  };
}
export default new CountryApi();
